<template lang="pug">
div
  .col-12.p-0.bin-description__text#bin-description(:class="descriptionClass")
    div(ref="description")
      p#bin_info_description(v-html="descriptionsWithLinks()", :class="fullDescriptionClass", :style="heightClass")
  .col-12
    button#bin_info_see_more_btn.bin-description__see-more-btn(
      v-if="notFullView"
      @click="seeMoreToggle"
    )
      | {{ seeMoreLabel }}
</template>

<script>
import mixins from 'common/mixins'
import { mapState } from 'vuex'
import { textProcessor } from 'common/links'
import binCardMixin from 'common/mixins/bin_card_mixin'
import { trackEvent } from 'common/metrics'

export default {
  mixins: [mixins.translate, binCardMixin.requests],
  name: 'bin-card-description-vue',
  props: {
    description: { type: Object, default: () => {} },
    fullView: { type: Boolean, default: false },
    descriptionHeight:{ type: Number, default: 0 }
  },
  data () {
    return {
      is_collapsed: true
    }
  },
  methods: {
    seeMoreToggle() {
      this.is_collapsed = !this.is_collapsed
      if (!this.is_collapsed) {
        trackEvent(
          'BIN',
          'Click Leer más',
          `${this.getCurrentView(this.fullView)}`
        )
      }
    },
    descriptionsWithLinks() {
      if(this.description && this.description.text && this.description.exprs)
        return textProcessor(gon.paisiso, this.description.text, this.description.exprs)
    },
  },
  computed: {
    seeMoreLabel() {
      return this.is_collapsed
        ? I18n.t('components.bin_card.read_more')
        : I18n.t('components.bin_card.read_less')
    },
    descriptionClass() {
      if(this.fullView) {
        return this.is_collapsed
        ? 'bin-description-collapsed-full'
        : 'bin-description-expanded'
      } else {
        return this.is_collapsed
        ? 'bin-description-collapsed'
        : 'bin-description-expanded'
      }
    },
    fullDescriptionClass() {
      return this.fullView ? 'bin-info-description-full' : 'bin-info-description'
    },
    notFullView() {
      return !this.fullView
    },
    heightClass(){
      return this.descriptionHeight==0 ? '' : {maxHeight: `${this.descriptionHeight - 16}px`}
    },
    ...mapState('search', ['searchTokens'])
  },
  watch: {
    searchTokens(){
      this.is_collapsed = true
    }
  },
  mounted() {
    this.$emit('bin_card_info_mounted')
  },
}
</script>
